(() => {
  const can = document.querySelector('[data-fkt-v2-can]');
  if (!can || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const update = () => {
    const section = can.closest('.fkt-v2-ingredient');
    const rect = section ? section.getBoundingClientRect() : can.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const scrollDistance = Math.max(1, rect.height - viewport);
    const progress = Math.min(1, Math.max(0, -rect.top / scrollDistance));
    const start = parseFloat(can.dataset.fktV2RotateStart || '0');
    const end = parseFloat(can.dataset.fktV2RotateEnd || '180');
    can.style.setProperty('--fkt-rotate', `${start + progress * (end - start)}deg`);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
